import { styled, FormControl, FormHelperText } from "@material-ui/core";
import BeerList from "components/beer-list";
import { brand } from "../../../theme";
import { FormLabel } from "../styles/shared";

export const BeerSelectionField = styled(({
    beers,
    beerPreselectedIndex,
    isBeerSelected,
    onClickBeer,
    ...p
}) =>
    <FormControl
        margin="normal"
        fullWidth
        {...p}
    >
        <FormLabel>Select Beer</FormLabel>
        <div className="card">
            <BeerList
                beers={beers}
                beerPreselectedIndex={beerPreselectedIndex}
                isBeerSelected={isBeerSelected}
                onClickBeer={onClickBeer}
            />
        </div>
        <FormHelperText className="hint">
            Already selected beers are greyed out but can still be selected.
        </FormHelperText>
    </FormControl>
)(({ theme }) => ({
    marginTop: theme.spacing(3),
    "& .card": {
        background: brand.white,
        borderRadius: 12,
        overflow: "hidden",
        boxShadow: "0 1px 4px rgba(26,18,5,0.06)",
    },
    "& .card .MuiList-root": {
        padding: 0,
    },
    "& .hint": {
        fontSize: 12,
        fontStyle: "italic",
        color: brand.textSec,
        marginTop: theme.spacing(1),
    },
}));
